export const TransactionType = {
  Advance: 'ADVANCE',
  Recovery: 'RECOVERY',
  Unknown: 'UNKNOWN',
  All: 'ALL'
};
